"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeaderInfoBox_1 = __importDefault(require("@Components/ContactUsHeader/HeaderInfoBox"));
const common_1 = require("@Const/common");
require("./index.scss");
const ContactUsHeader = () => (react_1.default.createElement("div", { className: 'contact-us-header' },
    react_1.default.createElement("h2", null, "Need Help?"),
    react_1.default.createElement("h5", null, "You've come to the right place!"),
    react_1.default.createElement("span", null,
        "Check out our",
        ' ',
        react_1.default.createElement("a", { href: '//help.themlc.com/en/support', target: '_blank', rel: "noreferrer" },
            "Help Center",
            ' '),
        "or",
        ' ',
        react_1.default.createElement("a", { href: '//themlc.com/frequently-asked-questions', target: '_blank', rel: "noreferrer" },
            "FAQ page",
            ' '),
        "- the answer you're looking for might be there already!"),
    react_1.default.createElement("span", null, "If you need additional help, send us an email, chat, or give us a call. The MLC Support Team is available Monday-Friday, 8am-6pm CT."),
    react_1.default.createElement("div", { className: 'header-info-box-section' },
        react_1.default.createElement(HeaderInfoBox_1.default, { buttonLink: '//help.themlc.com/en/support', buttonText: 'Visit Help Center', heading: 'Visit Help Center', imageType: common_1.ICONS.questionBlue, isButton: true },
            react_1.default.createElement("span", null, "Find immediate answers in our help articles.")),
        react_1.default.createElement(HeaderInfoBox_1.default, { buttonText: 'Chat with us', heading: 'Chat with us', imageType: common_1.ICONS.chatBubble, onClick: () => window.HubSpotConversations.widget.open(), isButton: true, btnClassName: 'mlc-launch-chat' }),
        react_1.default.createElement(HeaderInfoBox_1.default, { heading: 'Call us', imageType: common_1.ICONS.phoneBlue },
            react_1.default.createElement("p", null, "Talk to a live team member."),
            react_1.default.createElement("strong", null,
                react_1.default.createElement("a", { href: 'tel:6154883653' }, "(615) 488-3653"))))));
exports.default = ContactUsHeader;
